
import React, { Component } from 'react';
import { Container } from 'mdbreact';
import 'mdbreact/dist/css/mdb.css';
import '../log/log.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import MainLayout from '../layout/layout';
import { Redirect } from 'react-router-dom';
import RolesType from '../utils/roles';
import CompanyTaskService from '../Services/CompanyTaskService/companyTaskService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class Bulk extends Component {
    constructor(props) {
        super();
        this.state = {
            Filter: {
                FilterCompanyCode: "",
            },
            SelectCompanyCode: "",           
            loading: false,
            Punchloading: false,
            ViewCompanyCode: "",
            isAutenticated: true,
        };
        this.companyCodeSelectValue = this.companyCodeSelectValue.bind(this);
    }
    companyCodeSelectValue(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectCompanyCode = e.target.value;
        this.setState(stateCopy);
    }   
    DeleteRepeatedPunches() {

        var CompanyCode = this.state.SelectCompanyCode;
        var email = sessionStorage.getItem('email');
        var that = this;
        that.setState({
            Punchloading: true
        });
        if (CompanyCode === "" || CompanyCode === null || CompanyCode === undefined) {

            that.setState({
                Punchloading: false
            });
            toast.error("Company Code can not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var DataResult = CompanyTaskService.DeletePunches("1", CompanyCode, email);
        DataResult.then(function (data) {
            if(data.data === "OK") {
                that.setState({
                    Punchloading: false,
                });
                toast.success("Punch Deleted!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                Punchloading: false,
            });
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }    
    renderBulkRow1() {

        let dataResult = RolesType;
        var temp = Object.keys(dataResult);
        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] || sessionStorage.getItem("rol") === temp[4] ||
            sessionStorage.getItem("rol") === temp[5]) {
            return <div>
                <div className="row" >
                    {
                        this.renderBulkRow21()
                    }
                </div><br />
            </div>
        }
    }
    renderBulkRow21() {

        let dataResult = RolesType;

        var temp = Object.keys(dataResult);

        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] || sessionStorage.getItem("rol") === temp[4]) {
            return <div className="col-12" >
                <div className="card Logs" >
                    <div className="card-body" >
                        <Container >
                            <div className="row">
                                <div className="col-2">
                                    <h4><span className="badge badge-info">Company Taks</span></h4>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div style={{ 'paddingTop': '15px', 'width': 'auto' }}><label style={{ 'fontWeight': 'bold' }}>Company Code</label>  </div>
                                <div className="col-3" style={{ 'paddingTop': '10px', 'width': 'auto' }}>
                                    <input className="form-control" name="companycodeTask" id="companycodeTask" type="text" value={this.state.SelectCompanyCode} onChange={this.companyCodeSelectValue} />
                                </div>
                                <div className="form-group" style={{ paddingTop: 4 }}>
                                    {
                                        this.state.Punchloading
                                            ?
                                            <div>
                                                <ClipLoader
                                                    className={override}
                                                    sizeUnit={"px"}
                                                    size={30}
                                                    color={'#FF3547'}
                                                    loading={this.state.Punchloading}
                                                />
                                                <a className="btn btn-danger disabled" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.DeleteRepeatedPunches(e)} disabled><FontAwesomeIcon icon={faTrash} /> &nbsp;Remove Duplicated Punch</a>
                                            </div>
                                            :
                                            <div>
                                                <a className="btn btn-danger" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.DeleteRepeatedPunches(e)}><FontAwesomeIcon icon={faTrash} /> &nbsp;Remove Duplicated Punch</a>
                                            </div>

                                    }

                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        return (<div id="">
            <MainLayout />
            <ToastContainer hideProgressBar />
            <div className="container-fluid" >
                <div className="row">
                    <div className="col-6">
                        {this.renderBulkRow1()}
                    </div>
                </div>
            </div>
        </div>
        );
    }
}
export default Bulk;



// WEBPACK FOOTER //
// ./src/bulk/bulk.jsx